/**
 * Stable CSS class names for E2E — Paylens embed page.
 */
export const PL = {
    page: 'paylens-page',
    frameCard: 'paylens-page__frame-card',
    iframe: 'paylens-page__iframe',
} as const;
